import Vue from "vue";
import App from "./App";
import router from "./router";
import vuetify from "./plugins/vuetify";
import LCC from "lightning-container";
import store from "./store";
import i18n from "./plugins/i18n";

// ref: https://abhimediratta.github.io/vue-multiselect-listbox/guide/options.html#list-options
import vMultiselectListbox from "vue-multiselect-listbox";

import "./assets/css/font.css";
import "./assets/css/styles.scss";
import VueSweetalert2 from "vue-sweetalert2";

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

Vue.component("v-multiselect-listbox", vMultiselectListbox);

// Below is for initial LINE LIFF SDK from CDN
Vue.prototype.$liff = window.liff;

Vue.config.productionTip = false;
Vue.prototype.$lc = LCC;
i18n.silentTranslationWarn = true;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
